export default theme => ({
    root: {
        padding: 5,
        backgroundColor: 'white',
        boxShadow: props => theme.elevation[props.elevation],
        borderRadius: '.3rem',
        zIndex: 1200
    }
})